module.exports = __webpack_public_path__ + "static/media/me-you-rdu-main.c5a11dd9.svg";